import {svgIconWrapper} from '../svg-icon-wrapper';

import TextMagicRegular from './textmagic-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <TextMagicRegular {...props} />;
}

SvgComponent.iconName = 'textMagicRegular';

export const TextMagicRegularIcon = svgIconWrapper(SvgComponent);
